/* Mount with Data Hub's existing authenticated request helper, never a public service key. */
(function () {
  'use strict';
  window.FFProductWaitlistAdmin = {
    mount: function (root, request) {
      var product = '', before = null;
      function node(tag, text) { var n = document.createElement(tag); if (text) n.textContent = text; return n; }
      async function refresh(append) {
        if (!append) { before = null; root.replaceChildren(); }
        var data = await request('/product-waitlist/admin?' + new URLSearchParams(Object.assign({}, product ? { product: product } : {}, before ? { before: before } : {})));
        if (!append) {
          root.appendChild(node('p', 'Project requests and product waiting lists. Opening a spot queues one text during sending hours.'));
          if (data.bridge?.review_count || data.bridge?.failed_scans) {
            var warning=node('p', 'Older-page signup checks: ' + (data.bridge.review_count || 0) + ' need review; ' + (data.bridge.failed_scans || 0) + ' list checks are retrying. These people are not being subscribed again.'); warning.setAttribute('role','status'); root.appendChild(warning);
            (data.bridge.reviews || []).forEach(function (r) { root.appendChild(node('p', r.product + ' · profile ' + r.profile_id + ' · ' + r.reason.replaceAll('_',' '))); });
          }
          var select = node('select'); select.setAttribute('aria-label', 'Choose a product');
          [['', 'All products'], ['photo', 'Photo portraits'], ['story', 'Story portraits'], ['game', 'Game portraits'], ['project', 'Custom projects']].forEach(function (p) { var o = node('option', p[1]); o.value = p[0]; select.appendChild(o); });
          select.value = product; select.onchange = function () { product = select.value; refresh(false).catch(showError); }; root.appendChild(select);
        }
        (data.leads || []).forEach(function (lead) {
          var card = node('article'); card.className = 'ff-pw-owner-card';
          card.appendChild(node('h3', (lead.first_name || 'Waiting customer') + ' · ' + lead.product));
          card.appendChild(node('p', 'Status: ' + lead.status + (lead.held_jobs ? ' · Needs a check: ' + lead.held_jobs + ' messages' : '')));
          card.appendChild(node('p', [lead.email, lead.phone].filter(Boolean).join(' · ')));
          if (lead.details) Object.keys(lead.details).forEach(function (k) { if (lead.details[k]) card.appendChild(node('p', k.replace('project_', '').replaceAll('_', ' ') + ': ' + lead.details[k])); });
          if (lead.alert && !lead.acknowledged_at) {
            card.appendChild(node('strong', 'Needs your attention: ' + lead.alert.replaceAll('_', ' ')));
            var ack = node('button', 'Mark reviewed'); ack.type = 'button';
            ack.onclick = function () { action('/ack-alert', { lead_id: lead.id }); }; card.appendChild(ack);
          }
          if (lead.status === 'waiting') {
            var label = node('label', 'Verified private checkout link'); var input = node('input'); input.type = 'url'; input.placeholder = 'https://framedfantasy.com/cart/…'; label.appendChild(input); card.appendChild(label);
            var open = node('button', 'Open this spot and queue the text'); open.type = 'button';
            open.onclick = function () { if (input.reportValidity() && input.value) action('/open', { lead_id: lead.id, checkout_url: input.value }); }; card.appendChild(open);
          }
          if (['pending', 'waiting', 'open', 'needs_review'].includes(lead.status)) {
            var close = node('button', 'Close this request'); close.type = 'button';
            close.onclick = function () { if (window.confirm('Close this request and stop its remaining messages?')) action('/close', { lead_id: lead.id }); }; card.appendChild(close);
          }
          root.appendChild(card);
        });
        if (data.leads?.length === 100) {
          before = data.leads[data.leads.length - 1].created_at;
          var more = node('button', 'Show older requests'); more.type = 'button';
          more.onclick = function () { more.remove(); refresh(true).catch(showError); }; root.appendChild(more);
        }
      }
      function showError() { var p = node('p', 'Could not finish that action. Refresh and check before trying again.'); p.setAttribute('role', 'alert'); root.prepend(p); }
      async function action(path, data) {
        try { await request('/product-waitlist/admin' + path, { method: 'POST', body: JSON.stringify(data) }); await refresh(false); }
        catch (_) { showError(); }
      }
      refresh(false).catch(showError);
    }
  };
})();
